import { render, staticRenderFns } from "./OfficePolicyForm.vue?vue&type=template&id=c43e3d80&scoped=true&"
import script from "./OfficePolicyForm.vue?vue&type=script&lang=js&"
export * from "./OfficePolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficePolicyForm.vue?vue&type=style&index=0&id=c43e3d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43e3d80",
  null
  
)

export default component.exports